<template>
    <div class="warpper flex-sub">
        <div class="bg-white padding-sm margin-bottom-sm">
            <div class="flex align-center justify-between margin-bottom-sm list-title">
                <b>内置标签</b>
            </div>
            <ul class="sys-label">
                <li class="flex align-start">
                    <b>会员等级</b>
                    <div class="flex align-center flex-sub flex-wrap">
                        <div
                            v-for="(item, index) in levelList"
                            :key="index"
                            class="flex align-center justify-between label-item"
                            @click="showList(item,1)"
                        >
                            {{ item.name }} <span>{{ item.num }}</span>
                        </div>
                    </div>
                </li>
                <li class="flex align-start">
                    <b>缴费状态</b>
                    <div class="flex align-center flex-sub flex-wrap">
                        <div
                            v-for="(item, index) in feeList"
                            :key="index"
                            class="flex align-center justify-between label-item"
                            @click="showList(item,2)"
                        >
                            {{ item.name }} <span>{{ item.num }}</span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>


        <div class="bg-white flex-sub padding-sm margin-bottom-sm">
            <div class="flex align-center justify-between margin-bottom-sm list-title">
                <b> 自定义标签管理</b>
                <span class="add-btn" @click="laebelsDialog = true">
                    标签添加
            </span>
            </div>
            <el-empty description="暂无自定义标签" v-if="customList.length ===0"></el-empty>
            <div class="flex-sub flex align-center justify-between flex-wrap" v-else>
                <div v-for="(item, index) in customList" :key="index" class="custom-item"  @click="showList(item,3)">
                    <div class="custom-item-title">
                        <div class="flex align-center title-box">
                            {{ item.name }} <span>{{ item.usersCount }}</span>
                        </div>
                        <div class="custom-item-icon">
                            <i
                                class="el-icon-edit"
                                @click.stop="editLabels(item.id, item.name, item.user_id_str)"
                            ></i>
                            <i class="el-icon-delete" @click.stop="delLabels(item.id)"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-drawer
            :before-close="handleClose"
            :direction="direction"
            :visible.sync="drawer"
            :with-header="false"
            title=""
        >
            <div class="padding-sm">
                <h3 class="margin-bottom">{{ detailTitle + '(' + detailList.length + '家)' }}</h3>
                <div class="pople-list">
                    <p
                        v-for="(item, index) in detailList"
                        :key="index"
                        style="line-height: 150%;    padding: 5px;
    border-bottom: 1px dashed #ccc;
    margin-bottom: 5px;"
                    >
                        {{ index + 1 }}.{{ item.user_type === 1 ?  item.company : item.name }}
                    </p>
                </div>
            </div>
        </el-drawer>

        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :visible.sync="laebelsDialog"
            center
            title=""
            width="1200px"
        >
            <h3 class="flex align-center justify-around margin-bottom font-size-lg">
                自定义标签设置
            </h3>
            <div class="flex align-start margin-bottom-sm">
                <span class="label-title">标签名称</span>
                <div class="flex-sub">
                    <el-input v-model="labelName" placeholder="请输入标签名称"></el-input>
                </div>
            </div>
            <div class="flex align-start margin-bottom-sm ">
                <span class="label-title">会员选择</span>
                <div class="flex-sub width-100">
                    <el-transfer
                        ref="memberTransfer"
                        v-model="value"
                        :data="memberList"
                        :format="{
              noChecked: '${total}',
              hasChecked: '${checked}/${total}',
            }"
                        :props="{
              key: 'key',
              label: 'company',
            }"
                        :titles="['全部会员', '已选择会员']"
                        filterable
                        class="flex width-100 align-center"
                    >
                        <span slot-scope="{ option }">{{ option.label }}</span>
                    </el-transfer>
                </div>
            </div>

            <div class="flex align-center justify-around margin set-btn">
                <el-button class="line-btn" @click="closeLabels">关闭</el-button>
                <el-button class="blue-btn" type="primary" @click="saveLabels">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    allMember,
    customDel,
    customDetail,
    customEdit,
    customList,
    getUserFixedLableByFixedId,
    labelDetail,
    labelSelect
} from "@/api/organiz";

export default {
    name: "labels",
    data() {
        return {
            levelList: [],
            feeList: [],
            customList: [],

            drawer: false,
            direction: 'rtl',
            detailTitle: '',
            detailList: [],


            setId: '',
            laebelsDialog: false,
            labelName: '',
            value: [],
            memberList: [],
            renderFunc(h, option) {
                return <span>{option.key} - {option.label}</span>;
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.$emit('setIndex', [2, 1], '标签设置')
        this.getRankList()
    },
    components: {},
    methods: {
        //  删除自定义标签
        delLabels(id) {
            this.$confirm('此操作将删除该自定义标签, 是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.sureDelete(id)
            })
        },
        async sureDelete(id) {
            let _state = await customDel(id)
            if (_state.status === 200) this.$message.success(_state.msg), this.getRankList()
        },
        //  保存提交自定义标签
        async saveLabels() {
            if (!this.labelName) return this.$message.error('请输入标签名称')
            if (this.value.length === 0) return this.$message.error('请输入标签下的会员')
            if (this.setId) {
                await customEdit(this.labelName, this.value.join(','), this.setId)
                this.closeLabels()
                this.getRankList()
            } else {
                await customEdit(this.labelName, this.value.join(','))
                this.closeLabels()
                this.getRankList()
            }
        },
        clearSearch() {
            this.$refs.memberTransfer.clearQuery('left')
            this.$refs.memberTransfer.clearQuery('right')
        },
        //  修改自定义标签
        editLabels(id, title, ids) {
            this.setId = id
            this.laebelsDialog = true
            this.value = ids.split(',').map(Number)
            this.labelName = title
        },
        //  添加自定义标签
        addLabels() {
            this.laebelsDialog = true
            this.value = []
            this.labelName = ''
        },
        //  关闭定义标签
        closeLabels() {
            this.laebelsDialog = false
            this.value = []
            this.labelName = ''
            this.setId = ''
            this.clearSearch()
        },
        //  关闭标签会员列表
        handleClose() {
            this.detailTitle = ''
            this.detailList = []
            this.drawer = false
        },
        //  显示标签会员列表
        async showList(item, type) {
            if (type === 1) {
                if (item.num === 0) return this.$message.info('当前标签无数据')
                let _data = await labelDetail(item.id)
                this.detailTitle = item.name
                this.detailList = _data.data
                this.drawer = true
            } else if (type === 2) {
                if (item.num === 0) return this.$message.info('当前标签无数据')
                let _data = await getUserFixedLableByFixedId(item.id)
                this.detailTitle = item.name
                this.detailList = _data.data
                this.drawer = true
            } else {
                let _data = await customDetail(item.id)
                this.detailTitle = item.name
                this.detailList = _data.data
                this.drawer = true
            }
        },
        //  获取等级列表
        async getRankList() {
            let _list = await labelSelect()
            this.levelList = _list.data.rank
            this.feeList = _list.data.fixedFourLable
            let _list2 = await customList()
            this.customList = _list2.data || []
            let _allMember = await allMember()
            _allMember.data.map(item => {
                item.label =  item.user_type === 1 ? item.company  : item.name
                item.key = item.user_id
            })
            this.memberList = _allMember.data
        }
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.warpper {
    .bg-white {
        border-radius: 10px;
    }

    .list-title {
        b {
            font-size: 26px;
            line-height: 34px;
        }

        .add-btn {
            display: block;
            width: 200px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
            linear-gradient(#0a2240, #0a2240);
            background-blend-mode: normal, normal;
            border-radius: 20px;
            font-size: 16px;
            color: #fff;
            cursor: pointer;
        }
    }

    .sys-label {
        li {
            margin-bottom: 15px;

            b {
                display: block;
                width: 70px;
                line-height: 42px;
                text-align: right;
                font-size: 16px;
                margin-right: 15px;
            }

            .label-item {
                min-width: 180px;
                padding: 5px;
                border: 1px solid #f5f5f5;
                background: rgba($color: #0a2240, $alpha: 0.12);
                color: #0a2240;
                border-radius: 5px;
                margin: 0 10px 10px 0;
                cursor: pointer;

                span {
                    display: block;
                    min-width: 30px;
                    height: 30px;
                    padding: 0 5px;
                    background: #0a2240;
                    color: #fff;
                    border-radius: 5px;
                    text-align: center;
                    line-height: 30px;
                    margin-left: 15px;
                }
            }
        }
    }

    .custom-item {
        width: 49%;
        border-radius: 5px;
        border: 1px solid #ccc;
        margin-bottom: 20px;

        .custom-item-title {
            display: flex;
            align-items: center;
            padding: 10px;
            justify-content: space-between;
            background: rgba($color: #0a2240, $alpha: 0.12);
            color: #0a2240;

            .title-box {
                cursor: pointer;

                span {
                    display: block;
                    width: 30px;
                    height: 30px;
                    background: #0a2240;
                    color: #fff;
                    border-radius: 5px;
                    text-align: center;
                    line-height: 30px;
                    margin-left: 15px;
                }
            }
        }

        .custom-item-icon {
            padding: 10px;
            display: flex;
            align-items: center;
            justify-content: space-around;

            i {
                cursor: pointer;
                font-size: 22px;
                margin-left: 10px;
            }
        }
    }

    .label-title {
        line-height: 40px;
        font-size: 16px;
        margin-right: 15px;
    }

    .set-btn {
        width: 500px;
        margin: 0 auto;

        .el-button {
            width: 200px;
        }
    }
}
</style>